import { buildProps, definePropType } from "@xplus/utils/props";
import { useSizeProp } from "@xplus/hooks";
import type { ExtractPropTypes } from "vue";

export const selectProps = buildProps({
  options: {
    type: definePropType<Record<string, any>[]>(Array),
  },
  labelKey: {
    type: String,
    default: "text",
  },
  valueKey: {
    type: String,
    default: "id",
  },
  size: useSizeProp,
} as const);

export type SelectProps = ExtractPropTypes<typeof selectProps>;
